export default __webpack_public_path__ + "static/media/about-img-01@small.fd61ee40.jpg";